import { Environment } from "../enums";

const env = {
  SUPPORT_SOCKET_URL: "https://connect.myhook.site/support",
  // SUPPORT_SOCKET_URL: "http://localhost:8000/support",
  // CUSTOMPAGE_URL: "http://localhost:3002",
  CUSTOMPAGE_URL: "https://custompage.crmgenix.com",
  APP_URL: "https://app.crmgenix.com",
  // APP_URL: "http://localhost:3001",
  API_URL: "https://api.crmgenix.com",
  // API_URL: "http://localhost:8080",
  SUPER_ADMIN_API_URL: "https://connect.myhook.site",
  // SUPER_ADMIN_API_URL: "http://localhost:8000",
  //
  GHL: {
    APP_REF_ID: "68d3b7266e75c5a94d55bb1e",
    APP_ID: "68a5e2d7c2d332761196aebf",
    CLIENT_ID: "68a5e2d7c2d332761196aebf-mfxz2g4w",
    CLIENT_SECRET: "24c488a4-4c3b-47b8-b696-22a5e71f93bf",
    SSO_KEY: "20fafdbc-6ece-4f68-a540-cd6d60e98abb",
    AGENCY_APP_ID: "68496e333023a02bae0f1992",
    AGENCY_CLIENT_ID: "68496e333023a02bae0f1992-mciz3721",
    AGENCY_CLIENT_SECRET: "ff260c80-ddea-46bf-b756-8342240dade7",
    AGENCY_SSO_KEY: "6aef4986-3d15-4c42-a6d7-7aa737160bd2",
    SCOPE:
      "locations.readonly+conversations.readonly+conversations.write+conversations/message.readonly+conversations/message.write+conversations/reports.readonly+conversations/livechat.write+contacts.readonly+contacts.write+workflows.readonly+users.readonly+funnels/redirect.readonly+funnels/page.readonly+funnels/funnel.readonly+funnels/pagecount.readonly+funnels/redirect.write+oauth.write+oauth.readonly+companies.readonly+saas/company.read+saas/company.write+saas/location.read+saas/location.write+businesses.readonly+businesses.write+locations/customValues.readonly+locations/customValues.write+locations/customFields.readonly+locations/tasks.readonly+locations/tasks.write+locations/customFields.write+locations/tags.readonly+locations/tags.write+locations/templates.readonly",
  },
};
export default env;
